import { useEffect, useState } from "react";
import { useInterval } from "../utils/useInterval";
import { Window } from '@progress/kendo-react-dialogs';

//Logout after 15 minutes of inactivity, an hour on dev and local
const INACTIVE_LOGOUT_TIMER = process.env.REACT_APP_TIMEOUT_SECONDS;
const FIVE_MINUTE_WARNING = 5 * 60 * 1000;
//Check the inactive timer every 30 seconds
const INACTIVE_CHECK_TIMER = 30 * 1000;

interface AutoLogoutProps {
    handleLogOut: Function,
    children?: React.ReactNode
}

export const AutoLogout = (props: AutoLogoutProps) => {
    const [recentActivity, _setRecentActivity] = useState(Date.now());
    const [showLogoutWarning, setShowLogoutWarning] = useState(false);
    const [minutesRemaining, setMinutesRemaining] = useState(5);
    const logoutTimer = Number.parseInt(INACTIVE_LOGOUT_TIMER as string);

    const checkActivityAndLogout = () => {
        const currentDate = Date.now();
        if (currentDate - recentActivity > logoutTimer) {
            props.handleLogOut();
        } else if (currentDate - recentActivity > logoutTimer - FIVE_MINUTE_WARNING) {
            setShowLogoutWarning(true);
            setMinutesRemaining(Math.ceil((logoutTimer - (currentDate - recentActivity)) / (60 * 1000)));
        }
    }

    const setRecentActivity = () => {
        _setRecentActivity(Date.now());
        setShowLogoutWarning(false);
    }

    useEffect(() => {
        window.addEventListener("keypress", () => {
            setRecentActivity();
        });
        window.addEventListener("mousedown", () => {
            setRecentActivity();
        });
        window.addEventListener("mousemove", () => {
            setRecentActivity();
        });
    }, []);

    useInterval(checkActivityAndLogout, INACTIVE_CHECK_TIMER);

    return <>
        {showLogoutWarning &&
            <Window
                closeButton={() => null}
                maximizeButton={() => null}>
                <>You will be logged out due to inactivity within the next {minutesRemaining === 1 ? "minute" : minutesRemaining + " minutes"}. </>
            </Window>}
        {props.children}
    </>
}